var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { height: "100%" } },
    [
      _c("w-card-title", [_vm._v(" " + _vm._s(_vm.item.Data.title) + " ")]),
      _vm.open.length > 0
        ? _c(
            "w-scroll-view",
            { attrs: { tag: "w-card-content", "no-padding": "" } },
            _vm._l(_vm.open, function (client) {
              return _c(
                "w-row",
                {
                  key: client.IDContact,
                  staticClass: "openItem",
                  nativeOn: {
                    click: function ($event) {
                      return _vm.showOpen(client.IDContact)
                    },
                  },
                },
                [
                  _c("w-col", { attrs: { xs: "6" } }, [
                    _c("div", { staticClass: "client" }, [
                      _vm._v(" " + _vm._s(client.CompanyName) + " "),
                    ]),
                    _c("div", { staticClass: "itemCount" }, [
                      _vm._v(
                        " " +
                          _vm._s(client.ItemCount) +
                          " " +
                          _vm._s(
                            _vm.$ctc("documents", client.ItemCount, {
                              amount: client.ItemCount,
                            })
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                  _c(
                    "w-col",
                    { staticClass: "totalOpen", attrs: { xs: "6" } },
                    [_vm._v(" € " + _vm._s(_vm.humanFloat(client.Open)) + " ")]
                  ),
                ],
                1
              )
            }),
            1
          )
        : _c(
            "w-col",
            {
              staticClass: "no-items",
              attrs: { sm: "12", center: "", grow: "" },
            },
            [
              _c(
                "w-row",
                [
                  _c("w-fa", {
                    staticClass: "no-items-icon",
                    attrs: { icon: "check" },
                  }),
                ],
                1
              ),
              _c("w-row", { staticClass: "mt", attrs: { center: "" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("empty")) + " "),
              ]),
            ],
            1
          ),
      _c(
        "w-modal",
        { attrs: { value: _vm.showOpenBrowse } },
        [
          _c(
            "w-card",
            [
              _c(
                "w-card-title",
                [
                  _vm._v(_vm._s(_vm.$ct("open-documents-title"))),
                  _c("w-spacer"),
                  _c(
                    "w-link",
                    {
                      attrs: { white: "" },
                      on: {
                        click: function ($event) {
                          _vm.showOpenBrowse = false
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "times" } })],
                    1
                  ),
                ],
                1
              ),
              _c("app-sale-search-browse", {
                staticClass: "modal-content",
                attrs: {
                  view: _vm.view,
                  "filter-open": true,
                  "clear-view-settings-filters": "",
                  "allow-view-button": "",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }